export default __webpack_public_path__ + "static/media/facebook.9f3e3257.svg";